import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'; 
import { Facebook, Twitter, Linkedin, Instagram, Mail } from 'lucide-react';
import { colors } from '../../styles/designSystem';

const Footer = () => {
  const { t, i18n } = useTranslation(); 

  const links = {
    product: [
      { name: t('footer.sections.product.links.features'), href: '#features' },
      { name: t('footer.sections.product.links.case_studies'), href: '#examples' },
    ],
    company: [
      { name: t('footer.sections.company.links.about_us'), href: 'https://webproatlas.com/a-propos.html' },
      { 
        name: t('footer.sections.resources.links.privacy_policy'), 
        href: `/privacy-policy`,
        isRouterLink: true // Add this flag to identify router links
      },
      { 
        name: t('footer.sections.resources.links.terms_of_service'), 
        href: `/terms-of-service`,
        isRouterLink: true // Add this flag to identify router links
      }

    ],
    resources: [
      { name: t('footer.seo_links.voice_agent', 'AI voice agent'), href: `/${i18n.language}/agent-vocal-ia/`, isRouterLink: true },
      { name: t('footer.seo_links.pricing', 'Pricing'), href: `/${i18n.language}/tarifs/`, isRouterLink: true },
      { name: t('footer.seo_links.integrations', 'Integrations'), href: `/${i18n.language}/integrations/`, isRouterLink: true },
      { name: t('footer.seo_links.security', 'Security and GDPR'), href: `/${i18n.language}/securite-rgpd/`, isRouterLink: true },
    ],
    social: [
      { name: t('footer.social_links.facebook'), icon: Facebook, href: '#' },
      { name: t('footer.social_links.twitter'), icon: Twitter, href: '#' },
      { name: t('footer.social_links.linkedin'), icon: Linkedin, href: '#' },
      { name: t('footer.social_links.instagram'), icon: Instagram, href: '#' }
    ]
  };

  

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <h3 className={`${colors.text.heading} ${colors.primary.text} text-2xl mb-4`}>
              {t('footer.brand_name')}
            </h3>
            <p className={`${colors.text.body} mb-6 max-w-md`}>
              {t('footer.brand_description')}
            </p>
            <div className="flex items-center space-x-6">
              <div className="flex items-center">
                {/* <Phone className="w-5 h-5 text-violet-600 mr-2" /> 
               
                <span className={colors.text.subtitle}>{t('footer.contact_info.phone')}</span> */}
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 text-violet-600 mr-2" />
                <span className={colors.text.subtitle}>{t('footer.contact_info.email')}</span>
              </div>
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.sections.product.heading')}</h4>
            <ul className="space-y-3">
              {links.product.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className={`${colors.text.body} hover:text-violet-600 transition-colors`}>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.sections.company.heading')}</h4>
            <ul className="space-y-3">
          {links.company.map((link) => (
            <li key={link.name}>
              {link.isRouterLink ? (
                <Link 
                  to={link.href}
                  className={`${colors.text.body} hover:text-violet-600 transition-colors`}
                >
                  {link.name}
                </Link>
              ) : (
                <a 
                  href={link.href} 
                  className={`${colors.text.body} hover:text-violet-600 transition-colors`}
                >
                  {link.name}
                </a>
              )}
            </li>
          ))}
        </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.sections.resources.heading')}</h4>
            <ul className="space-y-3">
              {links.resources.map((link) => <li key={link.name}><Link to={link.href} className={`${colors.text.body} hover:text-violet-600 transition-colors`}>{link.name}</Link></li>)}
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className={colors.text.subtitle}>
              {t('footer.bottom_bar.copyright')}
            </p>

            <p className={`${colors.text.subtitle} text-sm text-center mt-4 md:mt-0`}>
              Conçu avec soin pour rendre votre activité visible.{' '}
              <a href="https://webproatlas.com/" className="hover:text-violet-600 transition-colors">WebProAtlas</a>{' '}
              <a href="https://webproatlas.com/a-propos.html" className="hover:text-violet-600 transition-colors">À propos</a>
            </p>
            
            <div className="flex space-x-6 mt-4 md:mt-0">
              {links.social.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="text-gray-400 hover:text-violet-600 transition-colors"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
